import React, { type ReactNode, useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import { loadLocaleData } from "@rovo-extension/i18n";

import { getLocale } from "../config";
import { logError } from "../utils/logger";

type Props = {
  children: ReactNode;
  locale?: string;
};

export const AppIntlProvider = (props: Props): JSX.Element => {
  const [messages, setMessages] = useState({});
  const locale = getLocale();

  useEffect(() => {
    loadLocaleData(locale)
      .then((localeMessages) => {
        setMessages(localeMessages);
      })
      .catch((error) => {
        logError({ error, impact: "Failed to load locale strings" });
      });
  }, [locale]);

  return (
    <IntlProvider locale={locale} messages={messages} onError={() => {}}>
      {props.children}
    </IntlProvider>
  );
};
